import styled, { css } from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { UserStatus } from '@/models/users.model';

const getStylesByStatus = (status?: UserStatus) => {
  switch (status) {
    case UserStatus.ACTIVE:
      return css`
        background: ${COLORS.GREEN_OLIVE};
        color: ${COLORS.DARK_GREEN};
      `;
    case UserStatus.DEACTIVATED:
    default:
      return css`
        background: ${COLORS.GREY_FADED_A};
        color: ${COLORS.GREY_FADED};
      `;
  }
};

export const StyledTag = styled.div<{ $status?: UserStatus }>`
  padding: 0.25rem;
  border-radius: 0.25rem;
  width: fit-content;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};

  ${({ $status }) => getStylesByStatus($status)}
`;
